export default [{
    path: '/administracao/grupos-relatorios',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Grupos Relatorios Historico',
        path: 'historico',
        component: () => import('@/views/gruposRelatorios/Historico.vue'),
        meta: {
          requiresAuth: true,
          admin: true,
          breadcrumb: [
            { name: 'Administração', path: '/administracao' },
            { name: 'Relatórios Modelos', path: '/administracao/relatorios-modelos/historico' },
            { name: 'Grupos de Relatórios' }
          ]
        }
      },
      {
        name: 'Grupos Relatorios Adicionar',
        path: 'edit',
        component: () => import('@/views/gruposRelatorios/Edit.vue'),
        meta: {
          requiresAuth: true,
          admin: true,
          breadcrumb: [
            { name: 'Administração', path: '/administracao' },
            { name: 'Relatórios Modelos', path: '/administracao/relatorios-modelos/historico' },
            { name: 'Grupos de Relatórios', path: '/administracao/grupos-relatorios/historico' },
            { name: 'Adicionar' },
          ]
        }
      },
      {
        name: 'Grupos Relatorios Editar',
        path: 'edit/:id',
        component: () => import('@/views/gruposRelatorios/Edit.vue'),
        meta: {
          requiresAuth: true,
          admin: true,
          breadcrumb: [
            { name: 'Administração', path: '/administracao' },
            { name: 'Relatórios Modelos', path: '/administracao/relatorios-modelos/historico' },
            { name: 'Grupos de Relatórios', path: '/administracao/grupos-relatorios/historico' },
            { name: 'Editar' },
          ]
        }
      }
    ]
  }]